export default "__VITE_ASSET__PWCErSDi__"